import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, take, takeUntil } from 'rxjs';
import { CardSummarySinglelineComponent } from 'src/app/core/card-summary-singleline/card-summary-singleline.component';
import { ToastService } from 'src/app/core/toast/toast.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { PoiDto } from './poi-dto';
import { PoiService } from './poi.service';

@Component({
  selector: 'app-poi',
  imports: [CardSummarySinglelineComponent, MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './poi.component.html',
  styleUrl: './poi.component.scss'
})
export class PoiComponent implements OnInit, OnDestroy {

  pois: PoiDto[] = [];
  loading = false;

  private theEnd$ = new Subject<void>();

  constructor(
    private localstorage: LocalStorageService,
    private router: Router,
    private poiService: PoiService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.localstorage.setTitolo('POI');
    this.loadPois();
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }

  edit(id: string): void {
    this.router.navigate([`/home/poi/${id}`]);
  }

  add(): void {
    this.router.navigate([`/home/poi/new`]);
  }

  delete(id: string): void {
    this.poiService.delete(id).pipe(take(1), takeUntil(this.theEnd$)).subscribe({
      next: () => {
        this.toast.success('POI eliminato');
        this.loadPois();
      },
      error: () => {
        this.toast.error('Errore durante l\'eliminazione del POI');
      }
    });
  }

  private loadPois(): void {
    this.loading = true;

    this.poiService.getAll().pipe(take(1), takeUntil(this.theEnd$)).subscribe({
      next: (data: PoiDto[]) => {
        this.pois = data;
        this.loading = false;
      },
      error: () => {
        this.toast.error('Errore durante il caricamento dei POI');
        this.loading = false;
      }
    });
  }
}
